import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AlertAdapter } from 'pg-ui-library';
import LeaveModuleService from 'src/services/leave-module.service';

export const useLeaveStatusChange = (): UseMutationResult<any, Error, { leaveStatus: any }, void> =>
  useMutation(({ leaveStatus }: { leaveStatus: any }) => LeaveModuleService.leaveStatus(leaveStatus), {
    onSuccess: () => {
      AlertAdapter('Leave updated Successfully', 'success');
    },
    onError: (e: Error) => {
      AlertAdapter(e.message, 'error');
    },
  });

export const useLeaveUpdate = (): UseMutationResult<any, Error, { leaveId: string; leaveUpdate: any }, void> =>
  useMutation(
    ({ leaveId, leaveUpdate }: { leaveId: string; leaveUpdate: any }) =>
      LeaveModuleService.leaveUpdate(leaveId, leaveUpdate),
    {
      onSuccess: () => {
        AlertAdapter('Leave updated Successfully', 'success');
      },
      onError: (e: Error) => {
        AlertAdapter(e.message, 'error');
      },
    }
  );
